import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { NotificationCard } from '../layout';

const BrowserWarningNotification = () => (
  <NotificationCard
    title="Your browser is outdated and not supported."
    description="Please, update your browser to continue using the application safely."
    accentColor="warning.main"
    accentSoftColor="background.warning"
    icon={<WarningAmberRoundedIcon sx={{ fontSize: 18 }} />}
  />
);

export default BrowserWarningNotification;
